import { configBuilder } from "ccui-framework";
import { commonConfig } from "../../../src/config/partner";

const Config = {
  cirqul: {
    ...commonConfig,
    reduxLogger: false,

    //layout
    layoutVersion: 3,
    //layout bottom images for layout v3
    // layoutOverlayImagesLeftImg:
    //   "https://cdn.cardcash.com/website/partners/cirqul/left.png",
    // layoutOverlayImagesRightImg:
    //   "https://cdn.cardcash.com/website/partners/cirqul/right.png",

    exchangeMastTextPartOneV1: "Redeem gift cards to",
    exchangeMastTextPartTwoV1: "pay down your balance",

    soundGoodAddAnotherCardLinkTxt: "+ Add Another Card",
    monthYearTextPlaceHolder: "MM/YY",
    cvvTextPlaceHolder: "CVV",
    orderCompleteCardInfoTxt: {
      text: (config) =>
        `If your trade order is accepted, your Cirqul Credit will be applied to your Cirqul Account. This process may take up to 3 business days.`,
    },

    headerBackTo: true,
    tloMissingNumberLink: "Missing Number? Learn why",
    identityTloTitle: "Choose your phone number",
    identityTloPassCodeTitle: "Enter the code ",
    identityTloErrorTitle: "Phone Number Information",
    identityTloExpiredTitle: "Expired",

    tloVerifyBtnTxt: "Continue",

    tloErrorTxt: `<p>The phone numbers we list are pulled from trusted third parties who provide numbers associated with your identity.
    We can not accept any other phone numbers for verification.</p>  <p> Security is of paramount importance to CardCash and we apologize if you are unable to continue. </p>`,

    // Verification
    verificationType: "tlo",
    // meta
    paymentType: "Gift Card",
    aOrAn: "a",
    partnerBrand: "Cirqul",
    partnerURL: "http://www.cirqul.com/",
    partnerEmail: "support@cardcash.com",
    giftCardTerms: "https://cirqul.com/learn/transparencycms/terms-conditions",
    termsAndConditionsBuilder: (config) =>
      `Restrictions apply, see <a href='${config.giftCardTerms}'>Terms and Conditions</a>`,

    cardDetailsTitle: "Provide Gift Card Details",
    identityCardInfoTitle: "Enter your credit card info",
    identityBillingInfoTitle: "Enter your billing info",

    // social
    facebookURL: "https://www.facebook.com/CardCash/",
    twitterURL: "https://twitter.com/CardCash",
    youTubeURL: null,
    instagramURL: "https://www.instagram.com/cardcash",
    googleURL: null,
    linkedInURL: null,
    pinterestURL: "https://www.pinterest.com/cardcash/",

    // api
    googleAnalytics: "",
    x_cc_app: "sFd2rQb5sL",
    baseURL: "https://production-api.cardcash.com/",

    // header
    headerMenuItemOrder: ["contactItem", "faqItem"],
    headerMenuFaqItem: {
      text: (config) => "FAQ",
    },

    headerLogoOrder: ["headerLogoCC", "headerLogoBrand"],
    headerLogoBrandIcon:
      "https://cdn.cardcash.com/website/partners/cirqul/cirqul_logo.png",
    soundsGoodSaveButtonTxt: "Get Offer",
    // steps
    stepsVersion: 3,
    stepsV3Text: [
      [
        "Get Offer",
        "Tell us about the brand and balance and get an instant offer.",
      ],
      ["Provide Details", "Enter the details for your gift card."],
      [
        "Verify Your Identity",
        "We’ll use this information to decide if we can accept your card.",
      ],
      [
        "Reduce Your Account Balance",
        "Your account balance will be updated within 3 business days.",
      ],
    ],

    // offer
    offerButtonTxt: "Get Instant Offer",
    offerButtonTxtMany: "Get Instant Offer",
    offerBalanceInputPlaceHolder: "$ Remaining Balance",

    // card number and pin input boxes
    cardNumberPlaceHolderText: "Gift Card Number",
    cardPinPlaceHolderText: "PIN",

    // Have another card? Add it here?
    haveAnotherCardShowPopup: false,

    sellInstructionsDesktopTitle: "How It Works?",
    exchangeMastTextPartThreeV1: "Over 300 Brands Accepted!",

    cardCashUrl: "https://www.cardcash.com",
    tloResendCodeLinkTxt: "Resend Code",
    orderCompleteShowBonusTxt: false,

    faqv3: {
      content: (config) => {
        return [
          {
            question: "How much will I receive in return for my gift card?",
            answer:
              "You'll receive credit toward your account for the full remaining balance on your gift card — no markdowns or exchange fees. Simply enter the card brand and current balance to confirm the amount. You're under no obligation to proceed, and we won't retain your card information if you don't complete the exchange.",
          },
          {
            question: "Do you accept partially used cards or uneven balances?",
            answer:
              "Yes, we accept gift cards with a balance of $10.00 or greater remaining on the gift card.",
          },
          {
            question: "Do I need to mail in my gift card?",
            answer: `No, you do not need to mail in your gift card. CardCash.com deals primarily with digital gift cards. Meaning if you have a physical card, you provide us with the card number and PIN so that we can "digitize" it. There is no need for you to physically mail the card to CardCash.com. Note: Some very small brands may not be digitizable.`,
          },
          {
            question: "Can I exchange more than one gift card?",
            answer: `Yes, you can exchange more than one gift card. To trade in more than one, click the "Add Another Card" link.`,
          },
          {
            question: "Why are some gift cards not accepted?",
            answer:
              "CardCash is a secondary gift card market and our priority is protecting our marketplace for both gift card sellers and buyers.  We use a combination of automated and manual fraud prevention solutions to help ensure all orders are cleared for potential risk, have the proper card balance, and are of interest to our buyer community.",
          },
          {
            question: "Do you accept merchandise credits?",
            answer: `Yes. Merchandise credits are issued when a customer returns a product in a store and the store issues them a "special" gift card called merchandise credit. It may have a different number series to distinguish it for the retailer, but it is really just a gift card.`,
          },
          {
            question: "Do you accept gift cards with expiration dates?",
            answer:
              "No, unfortunately, we cannot accept gift cards that have an expiration date.",
          },
          {
            question:
              "Do you accept Visa, Mastercard, or American Express branded Prepaid Cards?",
            answer: "No, unfortunately, we cannot accept prepaid cards.",
          },
          {
            question: "When will I receive my Cirqul credit?",
            answer:
              "It may take up to 3 business days for your balance to be updated in your Cirqul Account. You can check back in with CARA as well to get your latest balance details.",
          },
          {
            question: "The credit I received was less than what I was offered.",
            answer: `If you believe there was an error, please email us at <a href="mailto:connect@cirqul.com" target="_blank">connect@cirqul.com</a>`,
          },
          {
            question:
              "Can I get better rates for my cards or is it the same for all gift cards?",
            answer: `Through Cirqul's unique partnership with CardCash, every gift card is credited at its full remaining balance — no variable rates, no markdowns, regardless of brand. Simply enter your card information to confirm the current balance, and that amount is applied directly to your account. You're under no obligation to proceed, and we won't retain your card information if you don't complete the exchange.`,
          },
          {
            question: "What does CardCash.com do with the gift cards?",
            answer:
              "CardCash.com is one of the biggest gift card exchanges in the US. They repurpose and resell the gift cards at a discounted rate on their website.",
          },
          {
            question: "Why do I need to provide my credit card information?",
            answer:
              "Your credit card will be used to help verify your identity, and to protect our community from gift card fraud.",
          },
          {
            question: "Will you charge my credit card?",
            answer:
              "With every card redeemed, we place a $1 authorization charge to verify the validity of the credit card you provided. No actual funds will be debited from your card and the charge will fall off on its own within 24 hours.",
          },
          {
            question: "I changed my mind. How do I get my gift card back?",
            answer: `An order can be canceled at any time before it is fully processed by visiting <a href="https://www.cardcash.com/account/sell" target="_blank">https://www.cardcash.com/account/sell</a>.`,
          },
          {
            question: "I'm still confused, how can I reach you?",
            answer: `CardCash.com's customer service department can be reached during normal business hours or by email at <a href="mailto:support@cardcash.com" target="_blank">support@cardcash.com</a>. For questions related to Cirqul.com please email us at <a href="mailto:connect@cirqul.com" target="_blank">connect@cirqul.com</a>`,
          },
        ];
      },
    },

    theme: {
      background_color: "#4949FD",
      hyperlink_color: "#4949FD",
      primary_color: "#4949FD",
      secondary_color: "#7846FE",
      button_background_color: "#4949FD",
      button_font_color: "#FFFFFF",
      sell_instructions_bg_color: "#4949FD",
      progress_bar: "#7846FE",
    },
  },

  "test-cirqul": {
    googleAnalytics: "",
    x_cc_app: "iPh4qVd1mKa",
    baseURL: "https://integration-api.cardcash.com/",
    cardCashUrl: "https://test.cardcash.com",
    reduxLogger: true,
  },

  localhost: {
    googleAnalytics: "",
    x_cc_app: "iPh4qVd1mKa",
    baseURL: "https://integration-api.cardcash.com/",
    cardCashUrl: "https://test.cardcash.com",
    reduxLogger: true,
  },

  local: {
    googleAnalytics: "",
    x_cc_app: "iPh4qVd1mKa",
    baseURL: "https://integration-api.cardcash.com/",
    cardCashUrl: "https://test.cardcash.com",
    reduxLogger: true,
  },
};

export const configModule = configBuilder("cirqul", Config);
